import React, { useState, useEffect } from 'react';
import './programas.css';
import ModalProgramas from './modalprogramas';
import OwlFAB from '../../landingpage/pet/pet';
import carga from '../../carga/carga';
import {
  obtenerTodosProgramas,
  crearPrograma,
  actualizarPrograma,
  eliminarPrograma,
} from '../../../funtions';

function Programas() {
  const [programas, setProgramas] = useState([]);
  const [loading, setLoading] = useState(true);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [editingId, setEditingId] = useState(null);
  const [formData, setFormData] = useState({
    nombre: '',
    descripcion: '',
    descriptionp: '',
    categoria: '',
    codigo: '',
    pensum: '',
    materias_claves: [],
    perfil_egresado: '',
    campo_laboral: '',
    habilidades: [],
    requisitos: [],
    modalidades: [],
    cards: [],
    cardPrincipal: '',
    costes: [],
  });
  const [inputValues, setInputValues] = useState({
    materias_claves: '',
    habilidades: '',
    requisitos: '',
    modalidades: '',
    cards: '',
    coste_definicion: '',
    coste_valor: '',
  });
  const [searchTerm, setSearchTerm] = useState('');

  // Cargar programas al iniciar
  useEffect(() => {
    loadProgramas();
  }, []);

  const loadProgramas = async () => {
    try {
      setLoading(true);
      carga.mostrarCarga();
      const data = await obtenerTodosProgramas();
      setProgramas(data);
    } catch (error) {
      console.error('Error cargando programas:', error);
      alert('Error al cargar los programas');
    } finally {
      setLoading(false);
      carga.ocultarCarga();
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleArrayInputChange = (e) => {
    const { name, value } = e.target;
    setInputValues((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const addArrayItem = (field, itemOverride) => {
    if (field === 'costes') {
      const definicion = inputValues.coste_definicion.trim();
      const valor = inputValues.coste_valor;
      if (!definicion || valor === '') return;

      const nuevoCoste = { definicion, valor };
      setFormData((prev) => ({
        ...prev,
        costes: [...prev.costes, nuevoCoste],
      }));

      setInputValues((prev) => ({
        ...prev,
        coste_definicion: '',
        coste_valor: '',
      }));
      return;
    }

    const value = inputValues[field].trim();
    if (value) {
      // Si contiene comas, separar por comas; si no, agregar como un solo item
      const items = value.includes(',')
        ? value.split(',').map(item => item.trim()).filter(item => item !== '')
        : [value];

      setFormData((prev) => ({
        ...prev,
        [field]: [...prev[field], ...items],
      }));
      setInputValues((prev) => ({
        ...prev,
        [field]: '',
      }));
    }
  };

  const removeArrayItem = (field, index) => {
    setFormData((prev) => ({
      ...prev,
      [field]: prev[field].filter((_, i) => i !== index),
    }));
  };

  const moveArrayItem = (field, fromIndex, toIndex) => {
    setFormData((prev) => {
      const items = [...prev[field]];
      if (toIndex < 0 || toIndex >= items.length) return prev;
      const [item] = items.splice(fromIndex, 1);
      items.splice(toIndex, 0, item);
      return {
        ...prev,
        [field]: items,
      };
    });
  };

  const resetForm = () => {
    setFormData({
      nombre: '',
      descripcion: '',
      descriptionp: '',
      categoria: '',
      codigo: '',
      pensum: '',
      materias_claves: [],
      perfil_egresado: '',
      campo_laboral: '',
      habilidades: [],
      requisitos: [],
      modalidades: [],
      cards: [],
      cardPrincipal: '',
      costes: [],
    });
    setInputValues({
      materias_claves: '',
      habilidades: '',
      requisitos: '',
      modalidades: '',
      cards: '',
      coste_definicion: '',
      coste_valor: '',
    });
    setEditingId(null);
  };

  const openNewForm = () => {
    resetForm();
    setIsModalOpen(true);
  };

  const editPrograma = (programa) => {
    setFormData({
      nombre: programa.nombre || '',
      descripcion: programa.descripcion || '',
      descriptionp: programa.descriptionp || '',
      categoria: programa.categoria || '',
      codigo: programa.codigo || '',
      pensum: programa.pensum || '',
      materias_claves: programa.materias_claves || [],
      perfil_egresado: programa.perfil_egresado || '',
      campo_laboral: programa.campo_laboral || '',
      habilidades: programa.habilidades || [],
      requisitos: programa.requisitos || [],
      modalidades: programa.modalidades || [],
      cards: programa.cards || [],
      cardPrincipal: programa.cardPrincipal || '',
      costes: programa.costes || [],
    });
    setEditingId(programa.id);
    setIsModalOpen(true);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.nombre || !formData.codigo) {
      alert('El nombre y código son requeridos');
      return;
    }

    try {
      setLoading(true);
      carga.mostrarCarga();

      if (editingId) {
        await actualizarPrograma(editingId, formData);
      } else {
        await crearPrograma(formData);
      }

      await loadProgramas();
      setIsModalOpen(false);
      resetForm();
      alert(editingId ? 'Programa actualizado' : 'Programa creado');
    } catch (error) {
      console.error('Error guardando programa:', error);
      alert('Error al guardar el programa');
    } finally {
      setLoading(false);
      carga.ocultarCarga();
    }
  };

  const handleDelete = async (codigo) => {
    if (window.confirm(`¿Deseas eliminar el programa "${codigo}"?`)) {
      try {
        carga.mostrarCarga();
        await eliminarPrograma(codigo);
        await loadProgramas();
        alert('Programa eliminado');
      } catch (error) {
        console.error('Error eliminando programa:', error);
        alert('Error al eliminar el programa');
      } finally {
        carga.ocultarCarga();
      }
    }
  };

  const filteredProgramas = programas.filter(
    (p) =>
      p.nombre.toLowerCase().includes(searchTerm.toLowerCase()) ||
      p.codigo.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <div className="programas-container">
      <div className="programas-header">
        <h2>Gestión de Programas</h2>
        <button className="btn-create" onClick={openNewForm}>
          + Nuevo Programa
        </button>
      </div>

      <div className="programas-search">
        <input
          type="text"
          placeholder="Buscar por nombre o código..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          className="search-input"
        />
      </div>

      {loading && !isModalOpen ? (
        <div className="loading-state">Cargando programas...</div>
      ) : filteredProgramas.length === 0 ? (
        <div className="empty-state">
          <p>No hay programas</p>
        </div>
      ) : (
        <div className="programas-table-wrapper">
          <table className="programas-table">
            <thead>
              <tr>
                <th>Nombre</th>
                <th>Código</th>
                <th>Categoría</th>
                <th>Descripción</th>
                <th>Acciones</th>
              </tr>
            </thead>
            <tbody>
              {filteredProgramas.map((programa) => (
                <tr key={programa.id}>
                  <td className="cell-name">{programa.nombre}</td>
                  <td className="cell-code">{programa.codigo}</td>
                  <td>{programa.categoria}</td>
                  <td className="cell-description">
                    {programa.descripcion.substring(0, 50)}...
                  </td>
                  <td className="cell-actions">
                    <button
                      className="btn-edit"
                      onClick={() => editPrograma(programa)}
                      title="Editar"
                    >
                      ✏️
                    </button>
                    <button
                      className="btn-delete"
                      onClick={() => handleDelete(programa.id)}
                      title="Eliminar"
                    >
                      🗑️
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      {/* Modal separado */}
      <ModalProgramas
        isOpen={isModalOpen}
        editingId={editingId}
        formData={formData}
        inputValues={inputValues}
        onInputChange={handleInputChange}
        onArrayInputChange={handleArrayInputChange}
        onAddArrayItem={addArrayItem}
        onRemoveArrayItem={removeArrayItem}
        onMoveArrayItem={moveArrayItem}
        onSubmit={handleSubmit}
        onClose={() => setIsModalOpen(false)}
      />
      <OwlFAB />
    </div>
  );
}

export default Programas;
